import { tokens } from "../tokens";

/**
 * ADR-20261102-h2fd: the styles of the H2 design system's FormField, shared by TextField,
 * RadioGroup and Checkbox so every field carries the same label, help and error treatment.
 */
const c = tokens.colour;
const sp = tokens.spacing;

/** Label or legend: ink, bold, 4px above what follows, and still ink when focused or in error. */
export const fieldLabelSx = {
  color: c.neutral.ink,
  fontWeight: tokens.typography.weights.bold,
  mb: `${sp.xxs}px`,
  "&.Mui-focused, &.Mui-error": { color: c.neutral.ink },
  // H2 shows no required marker on any field; the control keeps `aria-required`.
  "& .MuiFormLabel-asterisk": { display: "none" },
} as const;

/** Help text: helper size in inkMuted, 8px above the control. */
export const fieldHelpSx = {
  display: "block",
  color: c.neutral.inkMuted,
  mb: `${sp.xs}px`,
} as const;

/** Error message: helper size, bold, errorText, 4px below the control. */
export const fieldErrorSx = {
  display: "block",
  color: c.status.error.text,
  fontWeight: tokens.typography.weights.bold,
  mt: `${sp.xxs}px`,
} as const;
